module.exports = __webpack_public_path__ + "media/WeChat_20211012163919.377cd1b5.mp4";